export const IDLE = 'IDLE';
export const LOADING = 'LOADING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const FULLY_LOADED = 'FULLY_LOADED';
export const PARTIALLY_LOADED = 'PARTIALLY_LOADED';
